export const makeOrderResponseTypes = {
  PAYMENT_PAGE_WITH_MESSAGE: 'PAYMENT_PAGE_WITH_MESSAGE',
  PAYMENT_PENDING_EXTERNAL_ACTION: 'PAYMENT_PENDING_EXTERNAL_ACTION',
  PAYMENT_REDIRECT: 'PAYMENT_REDIRECT',
  PRICE_CHANGE: 'PRICE_CHANGE',
  PROCESSING_ORDER: 'PROCESSING_ORDER',
  RECEIPT: 'RECEIPT',
} as const;

export const makeOrderResponseMessages = {
  DECLINED_BY_BANK: 'DECLINED_BY_BANK',
  GENERIC_ERROR: 'GENERIC_ERROR',
  MISSING_ERROR: 'MISSING_ERROR',
  NOT_ENOUGH_FUNDS: 'NOT_ENOUGH_FUNDS',
  PAYMENT_DETAILS_ERROR: 'PAYMENT_DETAILS_ERROR',
  PRECONDITIONS_VALIDATION_FAILED: 'PRECONDITIONS_VALIDATION_FAILED',
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
  THREE_D_FAILURE: 'THREE_D_FAILURE',
  USE_ANOTHER_CARD: 'USE_ANOTHER_CARD',
  CART_RESTART_FROM_SEARCH: 'CART_RESTART_FROM_SEARCH',
  PRICE_CHANGE_SHOW_CUSTOMER: 'PRICE_CHANGE_SHOW_CUSTOMER',
  CART_FAIL_CART: 'CART_FAIL_CART',
} as const;
